import React from 'react';
import { css, cx } from '@emotion/css';
import { color_shades_darker } from '../../../constants/colors';
import { breakpoint_small } from '../../../constants/breakpoints';

interface HeaderSeparatorProps {
    className?: string;
}

const HeaderSeparator = (props: HeaderSeparatorProps) => (
    <div className={cx(separatorStyle, props.className)} />
)

const separatorStyle = css`
    height: 48px;
    width: 1px;
    background: ${color_shades_darker};
    margin-right: 0;
    ${breakpoint_small} {
        display: none;
    }
`;

export default HeaderSeparator;